//获取login_email
if(localStorage.getItem('login_email')){
    $('.reset .email').val(localStorage.getItem('login_email'));
    localStorage.removeItem('login_email');
}else{

}
//重置密码获取验证码
$('.reset .getcode').click(function(e){
    e.stopPropagation();
    if(!isnetwork()){return false;};
    var that=$(this);
    let email=that.parents('.reset').find('.email').val();
    if(!email){
        //判断是否邮箱为空
        that.parents('.reset').find('.email').addClass('active');
        that.parents('.reset').find('.email').next().html(i18n[lang].email_empty);
        return false;
    }else if(!reg_email.test(email)){
        //正则判断格式是否正确
        that.parents('.reset').find('.email').addClass('active');
        that.parents('.reset').find('.email').next().html(i18n[lang].email_not_valid);
        return false;
    }else if(that.attr('class').indexOf('nobind')>0){
        return false;
    }else{
        that.addClass('nobind');
        that.next().html('');
        that.html(system_theme=='dark-theme'?'<img src="/images/account/loading.svg" alt="Loading">':'<img src="/images/account/loading-h.svg" alt="Loading">');
        //发送请求
        $.post(
            post_url+"account/authcode/email/password/reset",
            {
                e_id:murmur,
                email:email,
                language:lang.toLowerCase()
            },
            function(data){
                that.prev().removeAttr('readonly');
                that.prev().css('cursor','auto');
                sendCode(that,true);
                error_fn(data.code,that);
                switch(data.code){
                    case 0:
                        that.parents('.reset').find('.code').next().next().html(no_code_text);
                        that.parents('.reset').find('.password_box').show();
                        break;
                    case 20701:
                        that.parents('.reset').find('.email').addClass('active');
                        that.parents('.reset').find('.email').next().html(i18n[lang].error_20701);
                        break;
                    case 20702:
                        that.parents('.reset').find('.email').addClass('active');
                        that.parents('.reset').find('.email').next().html(i18n[lang].error_20702);
                        break;
                    case 20703:
                        that.find('p').html(i18n[lang].error_20703);
                        break;
                    case 20704:
                        that.parents('.reset').find('.email').addClass('active');
                        that.parents('.reset').find('.email').next().html(i18n[lang].error_20704);
                        break;
                    case 20705:
                        that.find('p').html(i18n[lang].error_20705);
                        break;
                    case 20706:
                        that.parents('.reset').find('.code').next().next().html(i18n[lang].error_20706);
                        break;
                }
                if(data.code!=0){
                    sendCode(that,false);
                }
            }
        ).error(function(xhr){
            that.prev().removeAttr('readonly');
            that.prev().css('cursor','pointer');
            sendCode(that,false);
            overtime(20799);
        });
    };
});
//点击重置密码
$('.reset .reset_btn').click(function(e){
    e.stopPropagation();
    reset_btn_fn($(this));
});
function reset_btn_fn(element,callback){
    if(!isnetwork()){return false;};
    let that=element;
    let email=that.parents('.reset').find('.email').val();
    let code=that.parents('.reset').find('.code').val();
    let password=that.parents('.reset').find('.password').eq(0).val();
    let copy_password=that.parents('.reset').find('.copy_password').val();
    if(!email){
        //判断邮箱是否为空
        that.parents('.reset').find('.email').addClass('active');
        that.parents('.reset').find('.email').next().html(i18n[lang].email_empty);
        return false;
    }else if(!reg_email.test(email)){
        //正则判断格式是否正确
        that.parents('.reset').find('.email').addClass('active');
        that.parents('.reset').find('.email').next().html(i18n[lang].email_not_valid);
        return false;
    }else if(!password){
        //判断秘密是否为空
        that.parents('.reset').find('.password').eq(0).next().html(i18n[lang].password_empty);
        return false;
    }else if(!reg_password.test(password)){
        //密码格式是否正确
        that.parents('.reset').find('.password').next().html(i18n[lang].password_not_valid_1);
        return false;
    }else if(!copy_password){
        //判断第二次秘密是否为空
        that.parents('.reset').find('.copy_password').next().html(i18n[lang].copy_password_empty);
        return false;
    }else if(!reg_password.test(copy_password)){
        //密码格式是否正确
        that.parents('.reset').find('.copy_password').next().html(i18n[lang].copy_passwords_inconsistent);
        return false;
    }else if(password!=copy_password){
        //判断两次密码是否一致
        that.parents('.reset').find('.copy_password').next().html(i18n[lang].copy_passwords_inconsistent);
        return false;
    }else if(!code){
        //判断验证码是否为空
        that.parents('.reset').find('.code').next().next().html(i18n[lang].code_empty);
        return false;
    }else if(!reg_code.test(code)){
        //判断验证码格式是否正确
        that.parents('.reset').find('.code').next().next().html(i18n[lang].code_not_valid);
        return false;
    }else{
        that.find('img').css('opacity',1);
        //发送请求
        $.post(
            post_url+"account/email/password/reset",
            {
                e_id:murmur,
                email:email,
                password:password,
                authcode:code
            },
            function(data){
                error_fn(data.code,that);
                that.find('img').css('opacity',0);
                switch(data.code){
                    case 0:
                        if(callback){
                            callback()
                            return false
                        }
                        autho_success(that);
                        break;
                    case 20801:
                        that.parents('.reset').find('.email').addClass('active');
                        that.parents('.reset').find('.email').next().html(i18n[lang].error_20801);
                        break;
                    case 20802:
                        that.parents('.reset').find('.password').eq(0).next().html(i18n[lang].error_20802);
                        break;
                    case 20803:
                        that.parents('.reset').find('.code').next().next().html(i18n[lang].error_20803);
                        break;
                    case 20804:
                        that.parents('.reset').find('.email').addClass('active');
                        that.parents('.reset').find('.email').next().html(i18n[lang].error_20804);
                        break;
                    case 20805:
                        that.parents('.reset').find('.password').eq(0).next().html(i18n[lang].error_20805);
                        break;
                    case 20806:
                        that.find('p').html(i18n[lang].error_20806);
                        break;
                    case 20807:
                        that.parents('.reset').find('.code').next().next().html(i18n[lang].code_not_valid);
                        break;
                    case 20808:
                        that.find('p').html(i18n[lang].error_20808);
                        break;
                }
            }
        ).error(function(xhr){
            that.find('img').css('opacity',0);
            overtime(20899);
        });
    };
}